<div id="product" class="page-layout carded fullwidth inner-scroll">
    
    <div style="margin: 10px; margin-top: 25px; text-align: center;">
        <mat-form-field style="margin-right: 10px;">
            <mat-label>De:</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="date_de">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker 
                #dp
                startView="multi-year"
                (yearSelected)="chosenYearHandler($event, 'de')"
                (monthSelected)="chosenMonthHandler($event, dp, 'de')"
                panelClass="example-month-picker">
            </mat-datepicker>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Para:</mat-label>
            <input matInput [matDatepicker]="para" [formControl]="date_para">
            <mat-datepicker-toggle matSuffix [for]="para"></mat-datepicker-toggle>
            <mat-datepicker 
                #para
                startView="multi-year"
                (yearSelected)="chosenYearHandler($event,'para')"
                (monthSelected)="chosenMonthHandler($event, para, 'para')"
                panelClass="example-month-picker">
            </mat-datepicker>
        </mat-form-field>

        <button 
            mat-mini-fab
            style=" margin-left: 10px"
            matTooltip="Filtrar"
            (click)="buscar()"
            [disabled]="disableButton">
            <mat-icon>search</mat-icon>
        </button>
    </div>

    <div 
        fxLayout="row" 
        fxlayoutalign="space-between center" 
        style="align-items: center; justify-content: center;"        
    >
        
        <div 
            class="fuse-card yellow-A200"
            *ngIf="totalEstrategias[2] !== undefined"    
            [@inOutAnimation]          
        >
            <div class="p-16">
                <div class="h1">
                    Financiamento Opções
                </div>
            </div>    
            <div class="p-16 pt-0 line-height-1.75 number-fuse-card" >
                <span>R$ {{ (totalEstrategias[2] !== undefined ? totalEstrategias[2] : 0 )  | number : '1.2-2' }}</span>
            </div>
        </div>
    
        <div 
            class="fuse-card accent-200"            
            *ngIf="totalEstrategias[1] !== undefined"
            [@inOutAnimation] 
        >
            <div class="p-16">
                <div class="h1">                    
                    Swing Trade
                </div>
            </div>    
            <div class="p-16 pt-0 line-height-1.75 number-fuse-card">
                <span>R$ {{ (totalEstrategias[1] !== undefined ? totalEstrategias[1] : 0 )  | number : '1.2-2' }}</span>
            </div>
        </div>

        <div 
            class="fuse-card yellow-800-bg"            
            *ngIf="totalEstrategias[15] !== undefined"
            [@inOutAnimation] 
        >
            <div class="p-16">
                <div class="h1" >                    
                    Finaciamento Opções Flexível
                </div>
            </div>    
            <div class="p-16 pt-0 line-height-1.75 number-fuse-card" >
                <span>R$ {{ (totalEstrategias[15] !== undefined ? totalEstrategias[15] : 0 )  | number : '1.2-2' }}</span>
            </div>
        </div>

        <div 
            class="fuse-card grey-500"            
            *ngIf="totalEstrategias[5] !== undefined"
            [@inOutAnimation] 
        >
            <div class="p-16">
                <div class="h1">                    
                    Buy and Holder
                </div>
            </div>    
            <div class="p-16 pt-0 line-height-1.75 number-fuse-card">
                <span>R$ {{ (totalEstrategias[5] !== undefined ? totalEstrategias[5] : 0 )  | number : '1.2-2' }}</span>           
            </div>
        </div>

        <div 
            class="fuse-card blue-grey"
            *ngIf="totalEstrategias[14] !== undefined"
            [@inOutAnimation] 
        >
            <div class="p-16">
                <div class="h1" >                    
                    High Perfomance             
                </div>
            </div>    
            <div class="p-16 pt-0 line-height-1.75 number-fuse-card">
                <span>R$ {{ (totalEstrategias[14] !== undefined ? totalEstrategias[14] : 0 )  | number : '1.2-2' }}</span>                
            </div>
        </div>

        <div 
            class="fuse-card green-200"
            *ngIf="total_dividendos > 0"
            [@inOutAnimation] 
        >
            <div class="p-16">
                <div class="h1" >                    
                    Dividendos             
                </div>
            </div>    
            <div class="p-16 pt-0 line-height-1.75 number-fuse-card">
                <span>R$ {{ total_dividendos | number : '1.2-2' }}</span>                
            </div>
        </div>

        <!--<div 
            class="fuse-card" 
            (click)="changeOpcao('hb')" 
            style="background-color: #000; color: #fff; cursor: pointer;">
            <div class="p-16">
                <div class="h1" style="text-align: center;">
                    <span *ngIf="inconsistenciasHB.length > 0" style="color: red; font-size: 24px">*</span>
                    Home Broker
                </div>
            </div>    
            <div class="p-16 pt-0 line-height-1.75" style="text-align: center; font-size: 20px;">                
                <span>R$ {{ total_hb | number : '1.2-2' }}</span>                
            </div>
        </div> -->

        <div 
            class="fuse-card green-700"
            *ngIf=" ( total_dividendos + totalGeral) != 0"
            [@inOutAnimation] 
        >
            <div class="p-16">
                <div class="h1">Resultado Aproximado</div>
            </div>    
            <div class="p-16 pt-0 line-height-1.75 number-fuse-card">
                <span>R$ {{ total_dividendos +  totalGeral | number : '1.2-2' }}</span>                
            </div>
        </div>

    </div>

    <p style="color: red; padding: 10px; font-size: 14px; text-align: justify; background-color: #fff59d;">
        <b>DISCLAIMER</b>: Essa ferramenta tem como objetivo facilitar o feedback junto ao cliente, 
        proporcionando o resultado aproximado das operações de Renda Variável,  
        como referência, utilizamos o preço de custo do ativo + despesas/encargos em geral. Em caso de dúvidas ou divergências ressaltamos que 
        deve prevalecer a informação oficial das respectivas notas de corretagem. Ressaltamos que, trata-se de informação restrita e sigilosa e sua circulação é
        terminantemente proibida, sob pena de sanções e severas multas pelo compliance da corretora.
    </p>

    <!-- LEGENDA -->
    <div class="legenda">  
        <h2 style="float: left; margin-right: 20px;">LEGENDA</h2>
        <div style="margin-top: 10px;">
            <div style="height: 40px; float: left; margin-right: 20px;">
                <div class="legenda-concluida"></div> 
                <span>Operação Concluida</span>
            </div>
            <div style="height: 40px; float: left; margin-right: 20px;">
                <div class="legenda-aberta"></div> 
                <span>Custódia em aberto</span>
            </div>
            <div style="height: 40px; float: left; margin-right: 20px;">
                <div class="legenda-incosistencia"></div> 
                <span>Incosistência</span>
            </div>            
        </div>
    </div>

    <!-- FINANCIAMENTO OPCAO-->
    <mat-card>
        <mat-card-header class="header-fop">
            <mat-card-title>
                <span  style="width: 100%; text-align: center;">Financiamento coberto de opções</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <!-- COMPRA / VENDA -->
            <div>
                <!-- OPCAO -->
                <div class="example-container" style="width: 10%;">
                    <h2>Derivativo</h2>
                    <div class="example-list">
                        <div class="example-box" style="background-color: #ccc; text-align: center; cursor: auto;" > 
                            <span style="text-align: center;"> Nº </span>
                        </div>
                        <div 
                            class="example-box" 
                            *ngFor="let p of premioList"                           
                            style="height: 60px;"                            
                            [ngClass] = "{ 
                                'status-nok': p.status == 'NOK', 
                                'status-ok': p.status == 'OK',
                                'op-select': p.selecionado
                            }"
                            (click)="selecionaOpcao(p)">
                            <span 
                                style="width: 100%; text-align: center;" 
                                *ngIf="premioList.length > 0" 
                                matTooltip="Clique aqui para adicionar um Derivativo">
                                {{ p.ativo != undefined ? p.ativo : p.texto }}
                            </span>
                        </div>
                        
                    </div>
                </div>
                <!-- / OPCAO -->

                <!-- COMPRA -->
                <div class="example-container">
                    <h2 style="text-align: center;">Compras</h2>
                    <div class="example-list" >
                        <div class="example-box" style="background-color: #ccc; cursor: auto" > 
                            <span>Data</span>
                            <span>Ativo</span>
                            <span>Preço</span>
                            <span>Qtd</span>
                            <span>Valor</span>
                        </div>
                        <div 
                            class="example-box" 
                            style="cursor: auto;"
                            *ngFor="let compra of compras" 
                            [ngClass] = "{ 
                                'status-nok': compra.status == 'NOK' , 
                                'status-ok': compra.status == 'OK',
                                'status-aberto': compra.status == 'ABE',
                                'status-inco': compra.status == 'INC' }"
                            >
                            <span>{{compra.data | date:'dd/MM/yyyy'}}</span>
                            <span 
                                style="padding: 5px; border-radius: 10px;"
                                [className]="compra.cor_ativo"
                            >
                                {{ compra.ativo }}
                            </span>
                            <span>{{compra.preco | number : '1.2-2'}}</span>
                            <span>{{compra.qtd | number : '1.0-0'}}</span>
                            <span>R$ {{compra.valor | number : '1.2-2'}}</span>
                        </div>
                    </div>
                </div>
                <!-- / COMPRA -->

                <!-- VENDA -->
                <div class="example-container">
                    <h2 style="text-align: center;">Vendas</h2>
                    <div                         
                        class="example-list">
                        <div class="example-box" style="background-color: #ccc; cursor: auto" > 
                            <span>Data</span>
                            <span>Ativo</span>
                            <span>Preço</span>
                            <span>Qtd</span>
                            <span>Valor</span>
                        </div>
                        <div 
                            class="example-box" 
                            *ngFor="let venda of vendas"
                            [ngClass] = "{ 
                                'status-nok': venda.status == 'NOK' , 
                                'status-ok': venda.status == 'OK',
                                'status-inco': venda.status == 'INC',
                                'bloqueado': venda.disabled,
                                'selecionado': venda.selecionado }"
                            (click)=addVenda(venda) >                            
                            <span *ngIf='venda.data != null'>{{ venda.data | date:'dd/MM/yyyy' }}</span>
                            <span *ngIf='venda.ativo != null'>{{ venda.ativo}}</span>
                            <span *ngIf='venda.preco != null'>{{ venda.preco | number : '1.2-2'}}</span>
                            <span *ngIf='venda.qtd != null'>{{ venda.qtd |  number : '1.0-0'}}</span>
                            <span *ngIf='venda.valor != null'>R$ {{ venda.valor | number : '1.2-2'}}</span>                            
                            <div *ngIf='venda.data == null'>
                                <span>{{venda.texto}}</span>                                
                            </div>
                        </div>
                    </div>
                </div>
                <!-- / VENDA -->

                <!-- RESULTADO -->
                <div class="example-container" style="width: 15%;">
                    <h2>Resultado</h2>
                    <div>
                        <div class="example-box" style="background-color: #ccc; text-align: center; cursor: auto;" > 
                            <span style="text-align: center;"> Total ( R$ ) </span>
                            <span style="text-align: right;"> % </span>
                        </div>
                        <div 
                            class="example-box-resultado" 
                            *ngFor="let resultado of resultadosFop"
                            [ngClass] = "{ 'negativo': resultado.valor < 0 , 'positivo': resultado.valor > 0 }">
                            <span style="font-size: 12px;">R$ {{ resultado.valor | number : '1.2-2' }}</span>
                            <span style="font-size: 12px;">{{ resultado.percentual | number : '1.2-2' }} %</span>
                            
                        </div>
                    </div>
                </div>
                <!-- / RESULTADO -->
                 
            </div>
            <!-- FIM COMPRA / VENDA -->

            <!-- INCOSISTENCIA -->
            <div *ngIf="inconsistencias.length > 0 ">
                <div class="example-container" style="width: 100%;">
                    <h2 style="text-align: center;">Operações Pendentes (Venda)</h2>
                    <div
                        class="example-list"                         
                        style="width: 100%;">
                        <div class="example-box" style="background-color: #ccc;" > 
                            <span>Tipo</span>
                            <span>Data</span>
                            <span>Ativo</span>
                            <span>Preço</span>
                            <span>Qtd</span>                            
                            <span>Valor</span>                            
                        </div>
                        <div 
                            class="example-box status-inco"
                            *ngFor="let inc of inconsistencias"
                            (click)="addIncosistencia(inc)">
                            <span>VENDA</span>
                            <span>{{inc.data | date:'dd/MM/yyyy'}}</span>
                            <span 
                                style="padding: 5px; border-radius: 10px;"
                                [className]="inc.cor_ativo"
                            >
                                {{inc.ativo}}
                            </span>
                            <span>{{inc.preco | number : '1.2-2'}}</span>
                            <span>{{inc.qtd | number : '1.0-0'}}</span>
                            <span>R$ {{inc.qtd * inc.preco | number : '1.2-2'}}</span>
                        </div>
                    </div
                    >
                </div>
            </div>
            <!-- FIM INCOSISTENCIA -->

            <!-- OPCAO -->
            <div
                *ngIf="opcoes"
            >
                <div class="example-container" style="width: 10%;">
                    <h2>Derivativo</h2>
                    <div
                        class="example-list" >
                        <div class="example-box" style="background-color: #ccc; text-align: center; cursor: auto;" > 
                            <span style="text-align: center;"> Nº </span>
                        </div>
                        <div 
                            class="example-box" 
                            *ngFor="let opcao of opcoes"
                            [ngClass] = "{ 'status-ok': opcao.status == 'OK' }"
                            (click)="addPremio(opcao)">
                            <span style="width: 100%; text-align: center;">
                                {{opcao.ativo}}
                            </span>
                        </div>
                    </div
                    >
                </div>
                <div class="example-container" style="width: 70%;">
                    <h2 style="text-align: center;">Prêmios</h2>
                    <div>
                        <div class="example-box" style="background-color: #ccc; cursor: auto" > 
                            <span>Data</span>
                            <span>Ativo</span>
                            <span>Preço</span>
                            <span>Qtd</span>                            
                        </div>
                        <div 
                            class="example-box-resultado"
                            *ngFor="let opcao of opcoes">
                            <span>{{opcao.data | date:'dd/MM/yyyy'}}</span>
                            <span
                                style="padding: 5px; border-radius: 10px;"
                                [className]="opcao.cor_ativo"
                            >
                                {{opcao.ativo}}
                            </span>
                            <span>R$ {{opcao.preco | number : '1.2-2'}}</span>
                            <span>{{opcao.qtd | number : '1.0-0'}}</span>
                        </div>
                    </div>
                </div>
                <div class="example-container" style="width: 15%;">
                    <h2>Resultado</h2>
                    <div>
                        <div class="example-box" style="background-color: #ccc; text-align: center; cursor: auto;" > 
                            <span style="text-align: center;"> Total ( R$ ) </span>                            
                        </div>
                        <div 
                            class="example-box-resultado"
                            *ngFor="let opcao of opcoes"
                            [ngClass] = "{ 'negativo': opcao.preco * opcao.qtd < 0 , 'positivo': opcao.preco * opcao.qtd > 0 }">
                            <span style="width: 100%; text-align: center;">
                                R$ {{opcao.preco * opcao.qtd | number : '1.2-2'}}
                            </span>
                        </div>
                        <div class="example-box-resultado ">
                            <span style="width: 100%; text-align: center;"> 
                                <b>R$ {{ total_opcao | number : '1.2-2'}}</b>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- FIM OPCAO -->

            <!-- DIVIDENDOS -->
            <div
                *ngIf="dividendos"
            >                
                <div class="example-container" style="width: 81%;">
                    <h2 style="text-align: center;">Dividendos</h2>
                    <div>
                        <div class="example-box" style="background-color: #ccc; cursor: auto" > 
                            <span style="width: 10%;">Data</span>
                            <span style="width: 20%;">Ativo</span>
                            <span style="width: 50%; text-align: center;">Tipo</span>
                            <span style="width: 20%;">Valor</span>                            
                        </div>
                        <div 
                            class="example-box-resultado"
                            *ngFor="let dividendo of dividendos">
                            <span style="width: 10%;">{{dividendo.data | date:'dd/MM/yyyy'}}</span>
                            <span
                                style="padding: 5px; border-radius: 10px; width: 20%;"                               
                            >
                                {{dividendo.ativo}}
                            </span>
                            <span style="width: 50%; text-align: center;">
                                {{dividendo.tipo_ativo == 'D' ? 'Dividendos' : 'Juros sobre capital' }}
                            </span>
                            <span style="width: 20%; text-align: right;">R$ {{dividendo.valor | number : '1.2-2'}}</span>
                        </div>
                    </div>
                </div>
                <div class="example-container" style="width: 15%;">
                    <h2>Resultado</h2>
                    <div>
                        <div class="example-box" style="background-color: #ccc; text-align: center; cursor: auto;" > 
                            <span style="text-align: center;"> Total ( R$ ) </span>                            
                        </div>
                        <div 
                            class="example-box-resultado positivo"
                            *ngFor="let dividendo of dividendos"
                        >
                            <span style="width: 100%; text-align: center;">
                                R$ {{dividendo.valor | number : '1.2-2'}}
                            </span>
                        </div>
                        <div class="example-box-resultado ">
                            <span style="width: 100%; text-align: center;"> 
                                <b>R$ {{ total_dividendos | number : '1.2-2'}}</b>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- FIM DIVIDENDOS -->

            
        </mat-card-content>
    </mat-card>
    <!-- FIM FINANCIAMENTO OPCAO-->
</div>